// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/end_user.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { EndUserService } from "./end_user";
import type { GetAuthApplicationResponse } from "./end_user";
import type { GetAuthApplicationRequest } from "./end_user";
import type { UpdateAuthApplicationResponse } from "./end_user";
import type { UpdateAuthApplicationRequest } from "./end_user";
import type { RegisterAuthApplicationResponse } from "./end_user";
import type { RegisterAuthApplicationRequest } from "./end_user";
import type { AcceptLegalResponse } from "./end_user";
import type { AcceptLegalRequest } from "./end_user";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { IsLegalAcceptedResponse } from "./end_user";
import type { IsLegalAcceptedRequest } from "./end_user";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service viam.app.v1.EndUserService
 */
export interface IEndUserServiceClient {
    /**
     * Returns whether the specified user has accepted end user license agreements.
     * If false, the user should not be able to use the application.
     *
     * @generated from protobuf rpc: IsLegalAccepted(viam.app.v1.IsLegalAcceptedRequest) returns (viam.app.v1.IsLegalAcceptedResponse);
     */
    isLegalAccepted(input: IsLegalAcceptedRequest, options?: RpcOptions): UnaryCall<IsLegalAcceptedRequest, IsLegalAcceptedResponse>;
    /**
     * Marks that the specified user has accepted end user license agreements.
     *
     * @generated from protobuf rpc: AcceptLegal(viam.app.v1.AcceptLegalRequest) returns (viam.app.v1.AcceptLegalResponse);
     */
    acceptLegal(input: AcceptLegalRequest, options?: RpcOptions): UnaryCall<AcceptLegalRequest, AcceptLegalResponse>;
    /**
     * Allows users to register third party auth applications using Viam linked to the indicated organization
     *
     * @deprecated
     * @generated from protobuf rpc: RegisterAuthApplication(viam.app.v1.RegisterAuthApplicationRequest) returns (viam.app.v1.RegisterAuthApplicationResponse);
     */
    registerAuthApplication(input: RegisterAuthApplicationRequest, options?: RpcOptions): UnaryCall<RegisterAuthApplicationRequest, RegisterAuthApplicationResponse>;
    /**
     * Allows users to update their third party auth applications
     *
     * @deprecated
     * @generated from protobuf rpc: UpdateAuthApplication(viam.app.v1.UpdateAuthApplicationRequest) returns (viam.app.v1.UpdateAuthApplicationResponse);
     */
    updateAuthApplication(input: UpdateAuthApplicationRequest, options?: RpcOptions): UnaryCall<UpdateAuthApplicationRequest, UpdateAuthApplicationResponse>;
    /**
     * Allows users to get the config for their third party auth applications
     *
     * @deprecated
     * @generated from protobuf rpc: GetAuthApplication(viam.app.v1.GetAuthApplicationRequest) returns (viam.app.v1.GetAuthApplicationResponse);
     */
    getAuthApplication(input: GetAuthApplicationRequest, options?: RpcOptions): UnaryCall<GetAuthApplicationRequest, GetAuthApplicationResponse>;
}
/**
 * @generated from protobuf service viam.app.v1.EndUserService
 */
export class EndUserServiceClient implements IEndUserServiceClient, ServiceInfo {
    typeName = EndUserService.typeName;
    methods = EndUserService.methods;
    options = EndUserService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Returns whether the specified user has accepted end user license agreements.
     * If false, the user should not be able to use the application.
     *
     * @generated from protobuf rpc: IsLegalAccepted(viam.app.v1.IsLegalAcceptedRequest) returns (viam.app.v1.IsLegalAcceptedResponse);
     */
    isLegalAccepted(input: IsLegalAcceptedRequest, options?: RpcOptions): UnaryCall<IsLegalAcceptedRequest, IsLegalAcceptedResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<IsLegalAcceptedRequest, IsLegalAcceptedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Marks that the specified user has accepted end user license agreements.
     *
     * @generated from protobuf rpc: AcceptLegal(viam.app.v1.AcceptLegalRequest) returns (viam.app.v1.AcceptLegalResponse);
     */
    acceptLegal(input: AcceptLegalRequest, options?: RpcOptions): UnaryCall<AcceptLegalRequest, AcceptLegalResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AcceptLegalRequest, AcceptLegalResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Allows users to register third party auth applications using Viam linked to the indicated organization
     *
     * @deprecated
     * @generated from protobuf rpc: RegisterAuthApplication(viam.app.v1.RegisterAuthApplicationRequest) returns (viam.app.v1.RegisterAuthApplicationResponse);
     */
    registerAuthApplication(input: RegisterAuthApplicationRequest, options?: RpcOptions): UnaryCall<RegisterAuthApplicationRequest, RegisterAuthApplicationResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterAuthApplicationRequest, RegisterAuthApplicationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Allows users to update their third party auth applications
     *
     * @deprecated
     * @generated from protobuf rpc: UpdateAuthApplication(viam.app.v1.UpdateAuthApplicationRequest) returns (viam.app.v1.UpdateAuthApplicationResponse);
     */
    updateAuthApplication(input: UpdateAuthApplicationRequest, options?: RpcOptions): UnaryCall<UpdateAuthApplicationRequest, UpdateAuthApplicationResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAuthApplicationRequest, UpdateAuthApplicationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Allows users to get the config for their third party auth applications
     *
     * @deprecated
     * @generated from protobuf rpc: GetAuthApplication(viam.app.v1.GetAuthApplicationRequest) returns (viam.app.v1.GetAuthApplicationResponse);
     */
    getAuthApplication(input: GetAuthApplicationRequest, options?: RpcOptions): UnaryCall<GetAuthApplicationRequest, GetAuthApplicationResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAuthApplicationRequest, GetAuthApplicationResponse>("unary", this._transport, method, opt, input);
    }
}
